import { render, staticRenderFns } from "./TableHistoricoPosVenda.vue?vue&type=template&id=8bd75794&scoped=true&"
import script from "./TableHistoricoPosVenda.vue?vue&type=script&lang=js&"
export * from "./TableHistoricoPosVenda.vue?vue&type=script&lang=js&"
import style0 from "./TableHistoricoPosVenda.vue?vue&type=style&index=0&id=8bd75794&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd75794",
  null
  
)

export default component.exports